import { JobFormManager } from 'jobs/job-form';

export class CreateJobStore {
   constructor() {}
   public readonly jobManager = new JobFormManager();
}
